import { Google, Pixall } from 'reaxl-analytics-handlers';

/**
 * @summary Sends Google/Pixall Click event when hide ad button is clicked
 * @data adType - One of: "Liner Ad", "Tower Ad", "Fluid Ad", "Footer Leader Ad", or "Sticky Footer Ad"
 */
export async function hideAdClick({
    data = {},
    state,
    dataLayer,
}, option) {

    const { adType } = data;

    const label = `hide_v - ${adType}`;

    Pixall.sendClickEvent({
        eventSource: 'advertisement',
        eventType: 'click',
        label,
        cdl: {
            eventProperties: {
                action: 'Click',
                element: 'Ad Closure',
                location: adType,
                tagIndex: 'srp-172',
            },
        },
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement: 'advertisement',
        eventResult: label,
    }, option);

    return { cmp: label };
}
